import { Flex, Typography } from "antd"

export const CryptocurrencyConversionStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        Here, you can instantly convert one cryptocurrency to another or
        exchange it for fiat currency from the available trading pairs.
      </Typography.Text>

      <ul>
        <li>Exchange rate updates every 15 seconds.</li>
        <li>
          After confirming the conversion, the funds will be credited to your
          Balances page.
        </li>
      </ul>
    </Flex>
  )
}
